import React from 'react';
import { Shield } from 'lucide-react';
export const Footer = () => {
  return <footer className="bg-navy-dark text-gray-400 py-8 md:py-12 border-t border-white/5" data-id="element-123">
      <div className="max-w-6xl mx-auto px-4 flex flex-col items-center text-center" data-id="element-124">
        <div className="flex items-center gap-2 font-bold text-white text-base md:text-xl tracking-tight mb-4 md:mb-6" data-id="element-125">
          <Shield className="w-5 h-5 md:w-6 md:h-6 text-teal" data-id="element-126" />
          mundodigitalarg.com
        </div>

        <div className="max-w-2xl mb-6 md:mb-8" data-id="element-127">
          <p className="text-white font-bold mb-2 flex items-center justify-center gap-2 text-sm md:text-base" data-id="element-128">
            🩺 MEGAPACK TO: AUTONOMÍA TOTAL™
          </p>
          <p className="text-xs md:text-sm leading-relaxed" data-id="element-129">
            El sistema clínico N°1 para Terapistas Ocupacionales domiciliarios
            en Argentina.
          </p>
        </div>

        <div className="flex flex-col md:flex-row gap-2 md:gap-8 mb-8 md:mb-12 text-xs md:text-sm font-medium" data-id="element-130">
          <a href="mailto:contacto@mundodigitalarg.com" className="hover:text-white transition-colors" data-id="element-131">
            contacto@mundodigitalarg.com
          </a>
          <span className="hidden md:inline text-gray-600" data-id="element-132">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-133">
            @mundodigitalarg
          </a>
        </div>

        <div className="text-[10px] md:text-xs text-gray-600" data-id="element-134">
          © mundodigitalarg.com™ 2026 — Todos los derechos reservados.
        </div>
      </div>
    </footer>;
};